export const userTags = [
  "User's Organizations",
  "User's Pending Invites",
  "Org's Pending Invites",
  'Org Projects',
  'Own Profile',
]
